import React, {useState, useRef, Fragment} from 'react';
import {Button} from 'devextreme-react/button';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import List from 'devextreme-react/list';
import './index.scss';
import ScrollView from 'devextreme-react/scroll-view';
import stampsIcon from '../../../../assets/stamps.png';
import UPSIcon from '../../../../assets/ups_icon.png';
import DHLIcon from '../../../../assets/dhl_icon.png';
import chinaPostIcon from '../../../../assets/china-post.svg';
import fedExIcon from '../../../../assets/fedEx_icon.png';
import Ups from './ups/index.js';
import Stamps from './stamps/index.js';
import ChinaPost from './china-post/index.js';
import DhlExpress from './dhl-express/index.js';
import FedEx from './fed-ex/index.js';
import DataGrid, {Column, Popup as GridPropUp, Editing, Position, Form as GridForm} from 'devextreme-react/data-grid';
import url from '../../../../api/base-url';
import sessions from '../../../../sessions';
import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';

const CarrierList = [
    {
        "key": 1,
        "name": "Stamps",
        "img": stampsIcon
    }, {
        "key": 2,
        "name": "UPS",
        "img": UPSIcon
    }, {
        "key": 3,
        "name": "DHL Express",
        "img":  DHLIcon
    },{
        "key": 4,
        "name": "Fed Ex",
        "img": fedExIcon
    }, {
        "key": 5,
        "name": "China Post",
        "img": chinaPostIcon
    }
];

const ServicesList = () => {
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [contentID, setContentID] = useState([]);
    const childRef = useRef();

    const  Services= () =>{
        switch(contentID){
            case 'UPS': 
                return(<Ups ref={childRef}/>);
            case 'China Post':
                return(<ChinaPost ref={childRef}/>);
            case 'DHL Express':
                 return(<DhlExpress ref={childRef}/>);
            case 'Stamps': 
                return(<Stamps ref={childRef}/>);
            case 'Fed Ex':
                return(<FedEx ref={childRef}/>);
            default:
                return 'Error 404 Page Not Found';
        }
    }

    function onSelectedItemKeysChange(args) {
        console.log("args", args);
        if (args?.name === 'selectedItemKeys') {
            if (args?.value[0]) {
                var item = args.value[0];
                setContentID(item.name);
                setIsPopUpVisible(true);
            }
        }
    }

    function onInitialized(){
        setContentID('');
    }

    function listServices(item) {
        
        return (
            <div  key={item.key}>
                <div className={'list-service'}>
                    <div className={'icon'}>
                        <div><img className={'channel-img'} alt={item.name} src={item.img}/></div>
                        <div>{item.name}</div>
                    </div>
                    <div>
                        { item.name === 'UPS' ?
                            <span className={'info'}>🗸 Access discounts up to 62%</span> : ''
                        }
                        { item.name === 'DHL Express' ?
                            <span className={'info'}>
                                <ul>
                                    <li>🗸 Access discounts up to 75%</li>
                                    <li>🗸 Schedule package pickups</li>
                                    <li>🗸 Pre-fill customs forms</li>
                                </ul>
                            </span> : ''
                        }
                    </div>
                </div>
            </div>
        )
    }

    const cancelButton = {
        text: 'cancel',
        onClick: () => {setContentID('');setIsPopUpVisible(false);}
    }

    const connectButton = {
        text: 'connect',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => childRef
            .current
            .onSubmit()
    }

    return (
        <React.Fragment>
            <Popup
                title={`Connect Your ${contentID} Service`}
                visible={isPopUpVisible}
                contentRender={Services}
                onHiding={e => { setContentID('');setIsPopUpVisible(false)}}>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={connectButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={cancelButton}>
                </ToolbarItem>
            </Popup>
            <ScrollView width="100%" height="100%">
                <List
                    dataSource={CarrierList}
                    itemRender={listServices}
                    onInitialized={onInitialized}
                    searchExpr="name"
                    searchEnabled={true}
                    searchMode={'contains'}
                    selectedItemKeys={contentID}
                    selectionMode={'single'}
                    onOptionChanged={onSelectedItemKeysChange}/>
            </ScrollView>
        </React.Fragment>
    );
}

export default function StoreSetUps() {
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const auth = sessions.getSession("user")?.accessToken;
    const dataSource = new CustomStore({
        key: '_id',
        load: () => {
            return fetch(`${url}/settings/stores`,
            {
                headers: {
                    "x-access-token": auth
                }
            }).then(response => response.json());
        },
        update: (key,values) => {
            return fetch(`${url}/settings/store/${ encodeURIComponent(key)}`,
            {
                method: "PUT",
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        },
        remove: (key) =>{
            return fetch(`${url}/settings/store/${ encodeURIComponent(key)}`,
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": auth
                }
            })
        } 
    });

    const onCellPrepared = (e) =>{
        if (e.rowType === "header" && e.column.command === "edit") {  
            e.cellElement.textContent = "Store Setup";  
          }  
    }

    return (
        <Fragment>
            <h4 className={'content-block'}>Carrier Setup</h4>
            <Popup
                title="Connect Carrier Account"
                visible={isPopUpVisible}
                width={500}
                onHiding={e => setIsPopUpVisible(false)}>
                <ScrollView width='100%' height='100%'>
                    <ServicesList/>
                </ScrollView>
            </Popup>
            <div className={'content-block'}>
                <Button
                    type={'default'}
                    text={' + Connect a Carrier Service'}
                    onClick={e => setIsPopUpVisible(true)}/>
            </div>
            <div className={'content-block'}>
               <DataGrid></DataGrid>
            </div>
        </Fragment>
    )
}